module.exports = __webpack_public_path__ + "120ccac7e8ef6dbe8702edce531457e0.svg";